import React, { useEffect, useMemo, useState } from "react";
import { TreeTable } from "primereact/treetable";
import { Column } from "primereact/column";
import { postAPICall, removeLeadingTextAndDash } from "../Api/Api.jsx";
import { InputText } from "primereact/inputtext";
import "./Style.css";
import { ProgressSpinner } from "primereact/progressspinner";
import { Button } from "primereact/button";
import Online from "../Images/Online.png";
import Offline from "../Images/Offline.png";
export default function Tree(props) {
  const [data, setData] = useState([]);
  const [searchFilter, setSearchFilter] = useState("");
  const [expandedKeys, setExpandedKeys] = useState({}); // Initialize as empty object
  const [loading, setLoading] = useState(true);
  const [selectedNodeKey, setSelectedNodeKey] = useState(null);
 
  useEffect(() => {
    fetchScheduleData();
  }, [localStorage.getItem("AccountGroupCode")]);

  const processedText = useMemo(() => {
    const text = props?.ScheduleinfoSelectedRowValue?.ScheduleName || "";
    return removeLeadingTextAndDash(text);
  }, [props?.ScheduleinfoSelectedRowValue?.ScheduleName]);
  useEffect(() => {
    setSearchFilter(processedText);
  }, [processedText]);
  const fetchScheduleData = async () => {
    let AccountGroupCode = localStorage.getItem("AccountGroupCode");
    const requestBody = {
      companyID: "1",
      accountGroupCode: AccountGroupCode,
    };
    let response = await postAPICall(
      "api/Global/HAPLiveHeirarchy",
      requestBody
    );
    if (response?.status === 200) {
      setLoading(false);
      transformData(response.data);
    } else {
      setData([]);
    }
  };
  //first method
  // const transformData = (data) => {
  //   const treeData = [];
  //   //const expandedKeysObject = {}; // Initialize an object to hold expanded keys

  //   const processNode = (node) => {

  //     const processedNode = {
  //       key: node.id.toString(),
  //       data: { ...node },
  //       children: [],
  //       liveTV:1  ,
  //       expanded: true//expandedKeys[node.id.toString()] || false,
  //     };

  //     const children = data.filter((item) => item.parentid === node.id);
  //     children.forEach((child) => {
  //       const processedChild = processNode(child);
  //       processedNode.children.push(processedChild);
  //     });

  //     return processedNode;
  //   };

  //   const rootNode = data.find((item) => item.parentid === 0);
  //   if (!rootNode) {
  //     console.error("Root node not found.");
  //     return;
  //   }

  //   treeData.push(processNode(rootNode));
  //   setData(treeData);

  //  // Extract node IDs and format into string format for expandedKeys
  //   // data.forEach((node) => {
  //   //   expandedKeysObject[node.id.toString()] = true; // Assuming all nodes are initially expanded
  //   // });

  //   // setExpandedKeys(expandedKeysObject);
  // };

  //method node level upto 3 auto expand
  const transformData = (data) => {
    const expandedKeysObject = {};

    const processNode = (node, level) => {
      const processedNode = {
        key: node.id.toString(),
        data: { ...node },
        children: [],
        expanded: level < 3, // Expand nodes up to level 5
      };

      const children = data?.filter((item) => item.parentid === node.id);
      processedNode.children = children.map((child) =>
        processNode(child, level + 1)
      );

      if (processedNode.expanded) {
        expandedKeysObject[processedNode.key] = true; // Mark this node as expanded
        children.forEach((child) => {
          expandedKeysObject[child.id.toString()] = true; // Mark child nodes as expanded
        });
      }
      return processedNode;
    };

    const rootNode = data?.find((item) => item.parentid === 0);
    if (!rootNode) {
      console.error("Root node with parentid=0 not found.");
      return;
    }

    const treeData = [processNode(rootNode, 1)]; // Start with level 1 for the root node
    setData(treeData);

    setExpandedKeys(expandedKeysObject);
  };

  // Usage

  ///method
  const getHeader = () => {
    return (
      <div
        id="plus_search"
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <InputText
          id="TreeSearch"
          type="search"
          value={searchFilter}
          onChange={(e) => setSearchFilter(e.target.value)}
          placeholder="Search..."
        />
        <Button
          icon="pi pi-search"
          id="searchicon"
          style={{
            backgroundColor: "lightslategray",
            border: "lightslategray",
          }}
          className="p-button-primary"
          title="Search"
        />
      </div>
    );
  };

  let header = getHeader();
  const onSelectionChange = (e) => {
    if (e.node.data) props.onclickcheck(e.node.data);
  };
  return (
    <div>
      {loading ? (
        <ProgressSpinner
          style={{ width: "50px", height: "30px", marginTop: "250px" }}
          strokeWidth="3"
        />
      ) : (
        <TreeTable
          globalFilter={searchFilter}
          header={header}
          value={data}
          scrollHeight="79vh"
          scrollable
          expandedKeys={expandedKeys}
          style={{ width: "auto", border: "1px slid black" }}
          onRowClick={(e) => {
            onSelectionChange(e);
          }}
          selectionKeys={selectedNodeKey}
          onSelectionChange={(e) => setSelectedNodeKey(e.value)}
          tableStyle={{ minWidth: "50rem" }}
          selectionMode="single"
          onToggle={(e) => setExpandedKeys(e.value)}
        >
          <Column
            field="name"
            header="Name"
            expander
            sortable
            style={{
              width: "90%",
              cursor: "pointer",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
            body={(rowData, index) => (
              <span title={rowData.data.name}>{rowData.data.name}</span>
            )}
          />
          <Column field="id" header="Id" hidden />
          <Column
            style={{ width: "20%", cursor: "pointer" }}
            field="TVStatus"
            header="Status"
            body={(node) => {
              if (node.data.nodekeylevel === "7") {
                return (
                  <>
                    {node.data.TVStatus === "ACTIVE" ? (
                      <img title="Active" src={Online} width={10} height={10} />
                    ) : (
                      <img
                        title="InActive"
                        src={Offline}
                        width={10}
                        height={10}
                      />
                    )}
                  </>
                );
              } else {
                return null; // Return null for nodes with nodekeylevel other than 7
              }
            }}
          />
        </TreeTable>
      )}
    </div>
  );
}
